export const noConversationsSelected = "AymJ";
export const oneConversationSelected = "YBM6Ed";
export const someConversationsSelected = "XzAH7";
export const oneConversationSelectedWithSize = "$bpgdc";
export const someConversationsSelectedWithSize = "U4xLUd";
export const oneItemSelectedWithSize = "LXzc3c";
export const someItemsSelectedWithSize = "gCLQk";
export default {noConversationsSelected,oneConversationSelected,someConversationsSelected,oneConversationSelectedWithSize,someConversationsSelectedWithSize,oneItemSelectedWithSize,someItemsSelectedWithSize};